import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Redirect home to workspace (Data Workspace OS)
    throw redirect({ to: '/workspace' });
  },
});
